import React from 'react';

const Dashboard = (props) => (
  <svg
    width={150}
    height={150}
    viewBox="0 0 150 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      width: 500,
      height: 500,
    }}
    {...props}
  >
    <style>
      {
        '\n     .working14-1 {animation:working14-1 5s infinite;}\n     @keyframes working14-1 {\n         0%{transform: translate3d(0, 0, 0); opacity: 0;}\n         20%{transform: translate3d(0, 10px, 0); opacity: 0;}\n         40%{transform: translate3d(0, 0, 0); opacity: 1;}\n         90%{transform: translate3d(0, 0, 0); opacity: 1;}\n         100%{transform: translate3d(0, 0, 0); opacity: 0;}\n     }\n     .working14-2 {animation:working14-2 5s infinite;}\n     @keyframes working14-2 {\n         0%{transform: translate3d(0, 0, 0); opacity: 0;}\n         30%{transform: translate3d(0, 10px, 0); opacity: 0;}\n         50%{transform: translate3d(0, 0, 0); opacity: 1;}\n         90%{transform: translate3d(0, 0, 0); opacity: 1;}\n         100%{transform: translate3d(0, 0, 0); opacity: 0;}\n     }\n     .working14-3 {animation:working14-3 5s infinite;}\n     @keyframes working14-3 {\n         0%{transform: translate3d(0, 0, 0); opacity: 0;}\n         40%{transform: translate3d(0, 10px, 0); opacity: 0;}\n         60%{transform: translate3d(0, 0, 0); opacity: 1;}\n         90%{transform: translate3d(0, 0, 0); opacity: 1;}\n         100%{transform: translate3d(0, 0, 0); opacity: 0;}\n     }\n     .working14-4 {animation:working14-4 5s infinite;}\n     @keyframes working14-4 {\n         0%{transform: translate3d(0, 0, 0); opacity: 0;}\n         50%{transform: translate3d(0, 10px, 0); opacity: 0;}\n         70%{transform: translate3d(0, 0, 0); opacity: 1;}\n         90%{transform: translate3d(0, 0, 0); opacity: 1;}\n         100%{transform: translate3d(0, 0, 0); opacity: 0;}\n     }\n     .working14-5 {animation:working14-5 5s infinite;}\n     @keyframes working14-5 {\n         0%{transform: translate3d(0, 0, 0); opacity: 0;}\n         60%{transform: translate3d(0, 10px, 0); opacity: 0;}\n         80%{transform: translate3d(0, 0, 0); opacity: 1;}\n         90%{transform: translate3d(0, 0, 0); opacity: 1;}\n         100%{transform: translate3d(0, 0, 0); opacity: 0;}\n     }\n     @media (prefers-reduced-motion: reduce) {\n         .working14-1, .working14-2, .working14-3, .working14-4, .working14-5 {\n             animation: none;\n         }\n     }\n    '
      }
    </style>
    <g
      className="working14-2"
      style={{
        animationDuration: '2s',
      }}
    >
      <path
        className="fillCls1"
        d="M42.176 40.8715H27.4175C27.2873 40.8676 27.1578 40.8925 27.0382 40.9443C26.9186 40.9961 26.8119 41.0737 26.7257 41.1714C26.6395 41.2692 26.5759 41.3847 26.5394 41.5098C26.5029 41.6349 26.4944 41.7665 26.5145 41.8953L28.0339 54.2631L30.0656 52.0055H43.4504C43.5906 52.0091 43.7298 51.9817 43.8582 51.9255C43.9867 51.8692 44.1011 51.7854 44.1935 51.6799C44.286 51.5745 44.3541 51.45 44.393 51.3153C44.4319 51.1806 44.4408 51.039 44.4189 50.9005L43.3127 41.884C43.2744 41.6077 43.139 41.3541 42.9307 41.1685C42.7224 40.983 42.4549 40.8777 42.176 40.8715V40.8715Z"
        fill="rgba(23,48,66,1)"
        strokeWidth="2px"
        style={{
          animationDuration: '2s',
        }}
      />
      <path
        className="strokeCls1"
        d="M29.4531 44.8193C33.3398 44.8713 37.2197 44.8713 41.0929 44.8193"
        stroke="#FFFFFF"
        strokeWidth="2px"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="strokeCls1"
        d="M29.7969 48.6064C32.8919 48.6486 35.9825 48.6569 39.0685 48.6313"
        stroke="#FFFFFF"
        strokeWidth="2px"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g
      className="working14-1"
      style={{
        animationDuration: '2s',
      }}
    >
      <path
        className="fillCls1"
        d="M48.0984 43.1346H62.8603C63.1422 43.1415 63.4125 43.2481 63.6231 43.4356C63.8338 43.6231 63.971 43.8792 64.0105 44.1584L65.5298 56.5262L62.9427 54.2687H49.5613C49.257 54.2613 48.9652 54.1461 48.7379 53.9438C48.5105 53.7414 48.3623 53.465 48.3197 53.1636L47.2123 44.146C47.1919 44.0192 47.1996 43.8894 47.2351 43.766C47.2705 43.6425 47.3328 43.5284 47.4174 43.4318C47.5021 43.3352 47.607 43.2585 47.7247 43.2071C47.8424 43.1557 47.97 43.131 48.0984 43.1346V43.1346Z"
        fill="rgba(23,48,66,1)"
        strokeWidth="2px"
        style={{
          animationDuration: '2s',
        }}
      />
      <path
        className="strokeCls1"
        d="M61.7932 47.0815C57.9193 47.132 54.039 47.132 50.1523 47.0815"
        stroke="#FFFFFF"
        strokeWidth="2px"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="strokeCls1"
        d="M62.134 50.8691C59.0487 50.9113 55.9604 50.9196 52.8691 50.894"
        stroke="#FFFFFF"
        strokeWidth="2px"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g
      className="working14-3"
      style={{
        animationDuration: '2s',
      }}
    >
      <path
        className="fillCls1"
        d="M31.5447 37.5415H47.7694L46.3517 26H30.127L31.5447 37.5415Z"
        fill="rgba(23,48,66,1)"
        strokeWidth="2px"
        style={{
          animationDuration: '2s',
        }}
      />
      <path
        className="strokeCls1"
        d="M33.3262 29.5615C36.4573 29.6044 40.9114 29.6484 44.0415 29.6913"
        stroke="#FFFFFF"
        strokeWidth="2px"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="strokeCls1"
        d="M33.8574 33.8901C36.0495 33.9206 38.8917 33.9511 41.4731 33.9804"
        stroke="#FFFFFF"
        strokeWidth="2px"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g
      className="working14-5"
      style={{
        animationDuration: '2s',
      }}
    >
      <path
        className="fillCls3"
        d="M5.93372 82.5862H20.5116L16.579 50.5566H2L5.93372 82.5862Z"
        fill="rgba(78,179,212,1)"
        strokeWidth="2px"
        style={{
          animationDuration: '2s',
        }}
      />
    </g>
    <path
      className="fillCls5"
      d="M97.6682 43.7041C97.6682 43.7041 100.105 40.5515 98.3037 33.6694C96.5022 26.7874 93.9738 25.8618 88.1155 27.7141C82.2573 29.5664 81.834 27.2886 81.834 27.2886C81.834 27.2886 82.1726 31.7201 85.3117 33.7586C88.4508 35.7971 95.6962 36.8604 95.6962 36.8604L97.6682 43.7041Z"
      fill="rgba(76,37,37,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls6"
      d="M99.3949 55.515L97.1769 40.3558C97.1769 40.3558 98.028 41.6572 99.6297 41.2069C101.231 40.7565 102.182 36.1523 100.33 34.8508C98.4772 33.5494 96.6261 35.501 96.6261 35.501L94.3686 31.3472C94.3686 31.3472 89.2135 33.5494 85.4096 33.099C85.4096 33.099 84.7098 37.5011 84.659 40.2102C84.6082 42.9192 84.659 47.0166 88.4629 47.0166L88.5126 57.2262L96.4206 58.0276L99.3949 55.515Z"
      fill="rgba(201,119,97,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls8"
      d="M90.5646 43.2952C89.9695 43.7695 89.2493 44.0606 88.4918 44.1332C87.7342 44.2059 86.9719 44.0568 86.2975 43.7042"
      fill="#111111"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls7"
      d="M94.7751 43.7036C94.7751 43.7036 92.2219 47.0064 88.4688 47.0064L88.4879 50.8599C88.4879 50.8599 91.8968 49.8339 94.7751 47.2073V43.7036Z"
      fill="rgba(156,85,77,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls1"
      d="M88.4479 35.7974L86.7773 40.5754L89.7448 39.7695L88.4479 35.7974Z"
      fill="rgba(23,48,66,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls8"
      d="M91.359 36.4715C91.5734 36.4715 91.7473 36.2643 91.7473 36.0087C91.7473 35.7531 91.5734 35.5459 91.359 35.5459C91.1445 35.5459 90.9707 35.7531 90.9707 36.0087C90.9707 36.2643 91.1445 36.4715 91.359 36.4715Z"
      fill="#111111"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls8"
      d="M86.452 36.8601C86.6316 36.8601 86.7771 36.6862 86.7771 36.4718C86.7771 36.2573 86.6316 36.0835 86.452 36.0835C86.2725 36.0835 86.127 36.2573 86.127 36.4718C86.127 36.6862 86.2725 36.8601 86.452 36.8601Z"
      fill="#111111"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls1"
      d="M92.547 39.1106C93.2668 39.0189 93.8015 38.5611 93.7412 38.088C93.6809 37.6149 93.0485 37.3057 92.3287 37.3974C91.6089 37.4891 91.0742 37.947 91.1345 38.4201C91.1948 38.8931 91.8272 39.2023 92.547 39.1106Z"
      fill="rgba(23,48,66,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls1"
      d="M84.9643 38.5024C84.8941 38.5026 84.824 38.5067 84.7544 38.5149C84.7069 39.1097 84.6742 39.6865 84.6641 40.2001C84.7634 40.2155 84.8638 40.2234 84.9643 40.2238C85.6901 40.2238 86.2782 39.8366 86.2782 39.3603C86.2782 38.884 85.6901 38.5024 84.9643 38.5024Z"
      fill="rgba(23,48,66,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls5"
      d="M33.7617 118.597V120.115C33.7617 120.266 33.7764 120.633 34.2076 120.633H93.2212C93.8149 120.633 94.7778 120.152 95.3659 119.558L102.403 113.076V110.113"
      fill="rgba(76,37,37,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls1"
      d="M134.925 86.9732L114.731 107.839L67.8438 112.081L68.2027 104.268L79.514 62.1293C81.6304 61.4385 86.1736 60.1145 88.2923 59.4203C88.3623 58.3954 88.2031 56.9844 88.272 55.9595C91.9269 57.1481 96.3121 57.1933 99.8982 55.2529C99.9049 56.2451 100.061 57.9958 100.071 59.006C106.013 60.3165 111.45 61.4961 116.94 63.5301C122.471 65.5788 125.97 66.1917 129.203 71.1266C131.536 74.6946 133.615 81.3882 134.925 86.9653"
      fill="rgba(23,48,66,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls5"
      d="M102.26 110.113H44.1921C43.6559 110.113 42.7247 110.549 42.1028 111.085L34.2884 117.878C33.671 118.415 33.6111 118.85 34.1428 118.85H92.2105C92.7467 118.85 93.6779 118.415 94.2999 117.878L102.111 111.084C102.732 110.548 102.797 110.113 102.26 110.113Z"
      fill="rgba(76,37,37,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls5"
      d="M14.5766 113.976C14.5698 114.025 14.5653 114.072 14.5608 114.121C14.0822 119.235 23.3538 118.906 28.3181 118.247C32.2608 117.725 34.9777 115.374 36.0185 113.409L34.2542 106.4L24.6688 106.174L16.0564 110.113L14.5766 113.976Z"
      fill="rgba(76,37,37,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls6"
      d="M21.7054 106.035C20.6399 106.26 17.8395 106.993 17.2525 107.451C16.2953 108.198 14.1428 111.159 13.5739 112.685C13.049 114.095 14.5424 114.457 16.117 113.137"
      fill="rgba(201,119,97,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls6"
      d="M27.782 103.516C26.3474 103.949 21.891 105.334 20.8413 106.135C19.585 107.092 17.0295 110.142 16.3263 111.608C15.219 113.911 17.4031 114.001 18.7791 112.804C20.2634 111.513 21.5005 109.784 22.487 109.095C22.9193 108.795 24.1181 108.557 25.3292 108.384L32.6661 107.206L33.3174 102.108L27.782 103.516Z"
      fill="rgba(201,119,97,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls6"
      d="M29.7054 104.233C27.3756 105.912 23.732 109.899 22.8199 112.327C21.8041 115.019 24.3742 114.66 25.6904 113.342C26.7063 112.327 28.738 109.454 30.1772 109.095C31.6163 108.736 33.0487 110.232 33.0487 110.232C33.0487 110.232 30.9549 111.548 29.2798 112.445C27.6047 113.342 26.7074 115.615 30.1772 115.077C33.647 114.54 35.8593 113.342 40.2231 111.847C40.8496 111.632 66.6778 104.27 66.6778 104.27"
      fill="rgba(201,119,97,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls3"
      d="M59.9654 104.27H83.6986C85.8658 104.27 87.3772 102.464 87.0724 100.233L81.8181 61.784C81.5133 59.5547 79.5087 57.7476 77.3403 57.7476H23.9422C21.7739 57.7476 20.2636 59.5536 20.5684 61.784L25.8228 100.233C26.1275 102.462 28.1322 104.27 30.3005 104.27H44.8017"
      fill="rgba(78,179,212,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls4"
      d="M52.7344 124.38H61.7091C64.4949 124.38 64.0795 122.505 60.5804 121.864C59.4087 121.649 58.307 121.412 57.1783 121.187"
      fill="rgba(50,68,103,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls4"
      d="M59.5653 91.4385H49.9483C49.2011 91.4385 48.5441 91.9667 48.3319 92.7354L44.2188 104.27H60.4728L61.2348 93.5142C61.3826 92.4216 60.5947 91.4385 59.5653 91.4385ZM56.6148 97.9853C56.3777 99.6705 54.82 101.033 53.1348 101.033C51.4496 101.033 50.2768 99.6671 50.5138 97.9853C50.7509 96.3034 52.3074 94.9376 53.9927 94.9376C55.6779 94.9376 56.8484 96.3045 56.6148 97.9886V97.9853Z"
      fill="rgba(50,68,103,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls3"
      d="M49.949 91.4385H59.566C60.5955 91.4385 61.3833 92.4216 61.2321 93.5142L57.1584 122.838C57.0354 123.724 56.3265 124.38 55.4924 124.38H41.8807C40.7519 124.38 39.9471 123.219 40.2654 122.059L48.3327 92.7354C48.5449 91.9667 49.2018 91.4385 49.949 91.4385Z"
      fill="rgba(78,179,212,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls4"
      d="M55.5016 100.069C56.8236 98.8367 57.0272 96.9066 55.9564 95.7579C54.8856 94.6093 52.946 94.6771 51.624 95.9094C50.3021 97.1417 50.0985 99.0718 51.1693 100.22C52.24 101.369 54.1797 101.301 55.5016 100.069Z"
      fill="rgba(50,68,103,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls2"
      d="M112.271 87.2729L114.913 99.2107L118.697 98.3054L116.197 92.6582L114.22 93.1583L112.271 87.2729Z"
      fill="#DE0020"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls6"
      d="M136.021 92.4024C135.773 90.8741 135.399 88.9958 134.924 86.9697L115.556 92.8517L116.939 97.0078C116.939 97.0078 100.49 100.836 96.4819 101.852C92.4737 102.868 86.971 103.884 83.2032 107.237C80.3892 109.738 78.4477 111.603 78.4477 112.919C78.4477 113.208 78.5606 113.585 78.9388 113.643C78.4873 114.272 78.178 114.874 78.2231 115.312C78.257 115.639 78.5934 115.763 79.0607 115.763C78.9442 115.986 78.8971 116.239 78.9252 116.489C79.1352 117.685 81.378 116.848 81.378 116.848L81.4254 116.83C81.0032 117.803 82.4752 118.22 83.8308 117.64C85.4438 116.948 92.1452 114.081 93.6724 113.701C94.4001 113.532 95.1311 113.379 95.8656 113.242C104.136 111.689 112.243 111.81 120.642 111.331C131.052 110.736 134.323 107.905 136.059 103.637C137.441 100.253 136.644 96.2447 136.021 92.4024Z"
      fill="rgba(201,119,97,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls9"
      d="M138.809 96.9826C140.555 93.4361 144.051 90.8083 145.153 87.0033C145.238 86.7121 145.307 86.4005 145.231 86.107C145.156 85.8136 144.893 85.5427 144.586 85.572C144.193 85.6036 143.994 86.0495 143.87 86.4231C142.868 89.4267 141.307 91.8073 139.373 94.3142"
      fill="rgba(90,216,183,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls9"
      d="M126.227 98.2831C127 96.423 127.888 94.5966 127.921 92.6044C127.94 92.3715 127.896 92.1378 127.795 91.9271C127.682 91.724 127.427 91.5817 127.207 91.6619C126.923 91.7657 126.869 92.136 126.849 92.4396C126.759 93.9663 126.464 95.4741 125.975 96.923"
      fill="rgba(90,216,183,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls9"
      d="M132.137 98.6491C134.197 95.1499 137.58 92.3574 138.712 88.453C138.807 88.1268 138.884 87.7758 138.799 87.4507C138.713 87.1256 138.416 86.8242 138.077 86.8513C137.637 86.8874 137.415 87.3852 137.276 87.804C136.155 91.1643 134.408 93.8281 132.245 96.632"
      fill="rgba(90,216,183,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls9"
      d="M140.701 86.1922C139.959 85.2735 139.165 84.3977 138.323 83.569C137.432 82.6818 136.551 81.6761 136.332 80.439C136.256 80.0123 136.375 79.4355 136.805 79.3847C137.21 79.3373 137.461 79.8001 137.615 80.1748C138.338 81.938 139.421 83.5013 140.9 85.1606"
      fill="rgba(90,216,183,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls9"
      d="M126.637 100.631C125.576 100.06 124.483 99.5509 123.363 99.1073C122.198 98.6366 120.993 98.0542 120.316 96.9988C120.08 96.6353 119.965 96.0585 120.342 95.8441C120.696 95.6432 121.107 95.9716 121.396 96.2595C122.75 97.6027 124.421 98.675 126.43 99.6277"
      fill="rgba(90,216,183,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls9"
      d="M132.429 90.3817C131.645 89.3512 130.544 88.2145 129.932 87.6061C129.041 86.7189 128.161 85.7132 127.941 84.4761C127.866 84.0494 127.985 83.4726 128.414 83.423C128.819 83.3744 129.069 83.8372 129.224 84.2131C129.947 85.9762 131.03 87.5395 132.509 89.1988"
      fill="rgba(90,216,183,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls5"
      d="M140.755 113.538L140.08 116.001H125.027L124.352 113.538"
      fill="rgba(76,37,37,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="strokeCls2"
      d="M134.482 68.3394C133.406 76.2802 131.926 95.1225 131.926 105.351"
      stroke="rgba(72,203,161,1)"
      strokeWidth="2px"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="strokeCls2"
      d="M142.827 76.2808C141.078 84.8943 138.651 94.8533 137.713 105.486"
      stroke="rgba(72,203,161,1)"
      strokeWidth="2px"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="strokeCls2"
      d="M122.371 84.6235C124.967 92.789 126.364 98.0828 127.62 105.485"
      stroke="rgba(72,203,161,1)"
      strokeWidth="2px"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls5"
      d="M142.336 105.486H122.775C120.198 105.486 118.109 107.575 118.109 110.151V110.153C118.109 112.729 120.198 114.818 122.775 114.818H142.336C144.912 114.818 147.001 112.729 147.001 110.153V110.151C147.001 107.575 144.912 105.486 142.336 105.486Z"
      fill="rgba(76,37,37,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls3"
      d="M135.133 69.265C133.737 69.5878 132.171 68.6272 131.826 67.2332C131.481 65.8392 132.415 64.2612 133.8 63.8921C135.185 63.523 136.782 64.4328 137.173 65.811C137.563 67.1892 136.681 68.7999 135.309 69.2142"
      fill="rgba(78,179,212,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls3"
      d="M133.838 65.1013C133.499 64.1125 133.058 63.0097 132.725 62.0209C133.087 62.2083 133.651 62.5119 133.651 62.5119C133.797 62.1407 133.913 61.7588 134 61.3696C134.083 61.6439 134.404 62.0469 134.583 62.2659L135.272 61.4701L135.577 62.4137C135.865 62.0873 136.199 61.8044 136.568 61.5739L136.293 62.8438C136.563 62.5554 136.876 62.3099 137.22 62.1157L135.843 64.9376"
      fill="rgba(78,179,212,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls3"
      d="M143.581 76.7019C142.378 76.7877 141.203 75.7854 141.098 74.5844C140.993 73.3834 141.975 72.1914 143.173 72.0662C144.372 71.9409 145.581 72.9048 145.725 74.0979C145.87 75.291 144.926 76.518 143.732 76.6816"
      fill="rgba(78,179,212,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls3"
      d="M143.023 73.1222C143.13 71.8242 143.2 70.4189 143.302 69.9922C143.362 70.2258 143.617 70.5724 143.754 70.7676L144.364 70.1254L144.59 70.9291C144.846 70.6683 145.138 70.4455 145.457 70.2676L145.177 71.3241C145.416 71.0922 145.688 70.8977 145.985 70.7473L144.72 73.0669"
      fill="rgba(78,179,212,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls3"
      d="M123.35 85.2065C122.348 85.877 120.83 85.5892 120.144 84.5981C119.457 83.6071 119.72 82.0844 120.7 81.3823C121.68 80.6802 123.206 80.9172 123.925 81.8857C124.644 82.8542 124.431 84.3836 123.473 85.1185"
      fill="rgba(78,179,212,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls3"
      d="M121.093 82.376C120.543 81.1965 119.907 79.9413 119.785 79.5202C119.952 79.6929 120.35 79.8679 120.564 79.9717L120.776 79.1116L121.365 79.7008C121.456 79.3462 121.598 79.0067 121.786 78.6929L122.066 79.7494C122.158 79.4287 122.298 79.1241 122.483 78.8464L122.534 81.4877"
      fill="rgba(78,179,212,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <path
      className="fillCls7"
      d="M117.62 98.9689L116.943 97.0083C116.943 97.0083 114.573 97.5591 111.412 98.2985L117.62 98.9689Z"
      fill="rgba(156,85,77,1)"
      strokeWidth="2px"
      style={{
        animationDuration: '2s',
      }}
    />
    <g
      className="working14-4"
      style={{
        animationDuration: '2s',
      }}
    >
      <path
        className="fillCls4"
        d="M4.50764 47.3845H23.4041L21.8555 34.7774L11.5398 27.7114L2.95898 34.7774L4.50764 47.3845Z"
        fill="rgba(50,68,103,1)"
        strokeWidth="2px"
        style={{
          animationDuration: '2s',
        }}
      />
      <path
        className="fillCls10"
        d="M6.5269 42.6526H20.2221L18.6972 30.2329H5.00195L6.5269 42.6526Z"
        fill="#FFFFFF"
        strokeWidth="2px"
      />
      <path
        className="fillCls3"
        d="M4.50764 47.3839H23.4041L21.8555 34.7769L13.2092 41.3033L2.95898 34.7769L4.50764 47.3839Z"
        fill="rgba(78,179,212,1)"
        strokeWidth="2px"
        style={{
          animationDuration: '2s',
        }}
      />
    </g>
  </svg>
);

export default Dashboard;
